import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {supportColors} from '../primitives/color';


export class FormWarning extends React.Component {
    static propTypes = {
        visible: PropTypes.bool,
        children: PropTypes.node.isRequired,
        onClose: PropTypes.func
    };

    renderCloseButton = () => {
        return (
            <I onClick={this.props.onClose} className="fa material-icons">close</I>
        );
    };

    render() {
        return (
            <WarningWrapper visible={this.props.visible}>
                {this.props.visible ? (
                    <Fragment>
                        <WarningTextWrapper>
                            {this.props.children}
                        </WarningTextWrapper>
                        {this.renderCloseButton()}
                    </Fragment>
                ) : null}
            </WarningWrapper>
        );
    }
}

const WarningWrapper = styled.div`
    height: 40px;
    background: ${props => props.visible ? 'rgba(255, 0, 0, 0.1)' : 'transparent'};
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
`;

const WarningTextWrapper = styled.div`
  height: 100%;
  padding: 10px 16px;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: ${supportColors.crimson};
`;

const I = styled.i`
  padding: 10px;
  font-size: 20px;
  color: ${supportColors.crimson};
  cursor: pointer;
`;
